import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUpload = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.001 14.3262C12.4565 14.3261 12.8261 13.9566 12.8262 13.501L12.8203 6.1123L14.8896 8.18164C15.2037 8.46677 15.6834 8.46711 15.998 8.18262C16.3356 7.87708 16.3618 7.35544 16.0566 7.01758L13.6445 4.60547C12.793 3.75452 11.4462 3.70218 10.5332 4.44727L10.3564 4.60645L7.94824 7.01172C7.62594 7.33379 7.62531 7.85633 7.94727 8.17871C8.26938 8.50104 8.7919 8.50079 9.11426 8.17871L11.1689 6.12598L11.1758 13.501C11.1758 13.9566 11.5453 14.3262 12.001 14.3262ZM17.7861 20.0771C18.9029 20.0768 19.79 19.0246 19.79 17.752V14.752C19.7899 14.308 19.4787 13.9272 19.0723 13.9268C18.6655 13.9268 18.3547 14.3077 18.3545 14.752V17.752C18.3545 18.1358 18.0891 18.4264 17.7861 18.4268H6.21484C5.91165 18.4268 5.64648 18.136 5.64648 17.752V14.752C5.6463 14.3079 5.33524 13.9271 4.92871 13.9268C4.52205 13.9269 4.21112 14.3079 4.21094 14.752V17.752C4.21094 19.0247 5.09787 20.0771 6.21484 20.0771H17.7861Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgUpload);
export default ForwardRef;
